<template>
  <div class="menu myMain" id="nav-menu">
    <!-- 头部导航 -->
    <el-header class="nav-menu" :style="{ background: backgroundColor }">
      <!-- LOGO位置 -->
      <div class="logo">
        <img
          src="@/assets/image/home/mobile/logo.png"
          alt="logo"
          class="hidden-md-and-up"
        />
        <img
          src="@/assets/image/home/logo_h.png"
          alt="logo 中田认证"
          class="hidden-sm-and-down"
        />
      </div>
      <!-- 导航菜单 -->
      <div class="right">
        <div class="menu-box hidden-sm-and-down">
          <el-menu
            class="el-menu-nav"
            :text-color="navColor"
            :active-text-color="activeColor"
            :background-color="backgroundColor"
            mode="horizontal"
            :default-active="$route.path"
            unique-opened
            router
          >
            <template v-for="(item, index) in filterRouter">
              <el-menu-item
                v-if="!item.children"
                :index="item.path"
                :key="'router' + index"
                >{{ item.meta.title }}</el-menu-item
              >
              <el-submenu v-else :key="index" :index="item.path" :popper-class="`submenu-popper${$route.meta.f ? '-sub' : ''} submenu-${index}`" :class="{'is-active': $route.meta.menuIndex == item.meta.menuIndex }">
                <template slot="title"><router-link :to="item.path">{{ item.meta.title }}</router-link></template>
                <el-menu-item v-for="(child, k) in subMenu[item.meta.menuIndex]" :key="'sub' + k" :index="child.link">{{ child.name }}</el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </div>
        <!-- 搜索框 -->
        <div class="seach hidden-sm-and-down">
          <el-input size="small" placeholder="请输入关键字" v-model="keyWords" @change="gotoSearch">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="gotoSearch"></i>
          </el-input>
        </div>
        <!-- 移动端导航 -->
        <ul class="m-nav-menu">
          <!-- 搜索 -->
           <el-input size="small" class="m-nav-search" placeholder="请输入关键字" v-model="keyWords" style="margin-left:10px">
            
           </el-input>
          <li @click="gotoSearch"><img src="@/assets/image/home/mobile/seach.png" alt="" /></li>
          <li><i class="line"></i></li>
          <!-- 登录 -->
          <li>
            <img v-if="!userNick" @click="showLogin()" src="@/assets/image/home/mobile/user.png" alt="" />
            <el-dropdown v-else placement="bottom" class="login-dropdown">
              <img src="@/assets/image/home/mobile/user.png" alt="" />
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><span @click="loginOut">退出</span></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li><i class="line"></i></li>
          <!-- 导航栏 -->
          <li @click="navHandel">
            <img src="@/assets/image/home/mobile/navmore.png" alt="" />
          </li>
        </ul>
      </div>
    </el-header>

    <!-- 移动端导航详情 -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="m-nav hidden-md-and-up" v-if="isShowNav">
        <ul>
          <li
            v-for="(item, index) in filterRouter"
            :key="index"
            @click="navClick(item)"
            :class="currentRouter == index ? 'm-active' : ''"
          >
            {{ item.meta.title }}
          </li>
        </ul>
      </div>
    </transition>
    <login-dialog :isShow.sync="loginDialogVisible" @upUser="upUser" />
  </div>
</template>
<script>
import { serviceMenu } from "@/utils/const.js";
import loginDialog from './loginDialog'
export default {
  props: {
    //导航栏背景颜色
    backgroundColor: {
      type: String,
      default: "#ffffff",
    },
    // 字体颜色
    navColor: {
      type: String,
      default: "#222222",
    },
    // 选中字体颜色
    activeColor: {
      type: String,
      default: "#DA5351",
    },
  },
  components: {
    loginDialog,
  },
  data() {
    return {
      keyWords: this.$route.query.kw || '',
      isShowNav: false,
      routesData: null,
      loginDialogVisible: false,
      userNick: localStorage.getItem('userNick'),
      subMenu: {
        1: serviceMenu,
        2: [
          { id: 20, name: "新闻通告", link: "/news?id=announce"}, 
          { id: 21, name: "田径文化", link: "/news?id=athletics"},
          { id: 22, name: "名录公示", link: "/news?id=directory"}]
      }
    };
  },
  created() {
    this.routesData = this.$router.options.routes;
  },
  computed: {
    filterRouter: function () {
      return this.routesData.filter((item) => item.meta.isShow == true);
    },
    currentRouter: function () {
      return this.$route.meta.menuIndex || 0;
    },
  },
  methods: {
    handleSelect(index) {
      this.$router.push(index);
    },
    //导航详情的显示与隐藏
    navHandel() {
      this.isShowNav = !this.isShowNav;
    },
    //记录点击的导航
    navClick(item) {
      this.isShowNav = false;
      this.$router.push(item.path);
    },
    gotoSearch(){
      // if(this.$route.path != '/search'){
        if(this.keyWords && this.keyWords.length > 0){
          this.$router.push('/search?kw='+this.keyWords);
        }
       
      // }else{
      //   this.$router.replace('/search?kw='+this.keyWords)
      // }
    },
    showLogin(){
      console.log('nav menu show login');
      this.loginDialogVisible = true;
    },
    upUser(val){
      this.userNick = val;
    },
    loginOut(){
      localStorage.clear();
      this.userNick = null;
    }
  },
  watch: {
      $route() {
          this.keyWords = this.$route.query.kw;
      }
  },
};
</script>

<style lang="scss">
#nav-menu {
  font-size: 14px;
  .nav-menu {
    display: flex;
    align-items: center;
    padding: 0;
    height: 100% !important;
    .logo {
      width: 66px;
      height: 43px;
      img {
        width: 100%;
      }
    }
    .right {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .menu-box {
        flex: 1;
        .el-menu-nav {
          display: flex;
          // justify-content: flex-end;
          margin-left: 60px;
          li {
            font-size: 16px;
            font-weight: 400;
            line-height: 16px;
            margin: 0;
            padding: 0 !important;
            margin-right: 52px;
            height: 80px;
            display: flex;
            align-items: center;
          }
          >.el-submenu.is-active{
            border: none;
          }
          >.el-submenu .el-submenu__title{
            padding: 0;
          }
          >.el-submenu.is-active .el-submenu__title{
            border-bottom: 2px solid #DA5351!important;
            color: #DA5351!important;
          }
          .el-submenu__title{
            font-size: 16px;
            font-weight: 400;
            line-height: 16px;
            height: 80px;
            display: flex;
            align-items: center;
            background: transparent!important;
            a{
              color: inherit;
              text-decoration: none;
            }
            .el-submenu__icon-arrow{
              display: none;
            }
          }
        }

      }
      .seach {
        // margin-right: 4px;
        .el-input--small .el-input__inner {
          width: 260px;
          height: 28px;
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #e4e4e4;
        }
        input::-ms-input-placeholder {
          font-size: 14px;
        }
        input::-webkit-input-placeholder {
          color: #b2b2b2;
          font-size: 14px;
        }
        .el-input--small .el-input__icon {
          font-size: 14px;
        }
      }
    }
  }
  .m-nav-menu {
    display: none;
  }
  //取消el组件的下滑先
  .el-menu.el-menu--horizontal {
    border: none;
  }
  // hover样式
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
    outline: 0;
    background-color: transparent !important;
  }
}

.el-menu--horizontal .el-menu--popup{
  // background: rgba(255, 255, 255, .39) !important;
  background: rgba(0, 0, 0, .2) !important;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  padding: 20px 24px 0;    
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 188px;
  box-sizing: border-box;
  .el-menu-item{
    margin-right: 0;
    margin-bottom: 20px;
    color: #FFFFFF !important;
    height: unset;
    background: transparent !important;
    line-height: 22px;
    box-sizing: border-box;
  }
}
.el-menu--horizontal.submenu-popper-sub  .el-menu--popup{
  background: rgba(0, 0, 0, .2) !important;
}
.el-menu--horizontal.submenu-1 .el-menu--popup{
  width: 352px;
}
.el-menu--horizontal.submenu-2  .el-menu--popup{
  width: 112px;
  height: auto;
}
.el-menu--popup-bottom-start{
  margin-top: 0;
}
//移动端
@media screen and (max-width: 960px) {
  #nav-menu {
    position: fixed;
    top: 0;
    z-index: 2999;
    .nav-menu {
      background: #cc3b3f !important;
      padding: 0.14rem 0.16rem;
      .logo {
        width: 0.43rem;
        height: 0.28rem;
      }
      .m-nav-menu {
        display: block;
        display: flex;
        align-items: center;
        li {
          img {
            width: 0.14rem;
            height: .14rem;
            vertical-align: middle;
            object-fit: contain;
          }
          .el-dropdown-selfdefine{
            height: auto;
          }
          .line {
            display: inline-block;
            width: 0.01rem;
            height: 0.12rem;
            background: #ffffff;
            border-radius: 0.01rem;
            opacity: 0.5;
            margin: 0 0.12rem;
            vertical-align: middle;
          }
        }
      }
    }

    .m-nav {
      position: relative;
      top: 0;
      z-index: 2999;
      width: 100%;
      height: 100%;
      background-color: #fff;
      ul {
        padding: 0 0.14rem;
        li {
          color: black;
          padding: 0.14rem 0;
          border-bottom: 0.01rem red dashed;
          text-align: left;
          &:last-child {
            border-bottom: none;
          }
        }
        .m-active {
          color: #cc3b3f !important;
        }
      }
    }
    .m-nav-menu {
      .m-nav-search{
        font-size: .14rem;
        margin-right: .1rem;
        .el-input__inner{
          height: .32rem;
          line-height: .32rem;
        }
      }
    }
  }
  .el-dropdown-menu{
      z-index: 3000 !important;
    }
}
</style>
